import Alert from '@material-ui/lab/Alert';
import * as React from 'react';

function DateLimitAlert() {
  return (
    <>
      <Alert severity='info' color='warning'>
        O acesso a Documentos Fiscais da aba Notas a Clientes a partir de <strong> 01/04/2023 </strong> deve ser acessado no{' '}
        <a href='https://my2.eduzz.com/docs-fiscais' target='_blank' rel='noopener noreferrer'>
          novo serviço!
        </a>
      </Alert>
      <div className='m16' />
    </>
  );
}

export { DateLimitAlert };
